import { GoogleApiWrapper } from 'google-maps-react';
import GoogleMapsDiv from './googleMapsDiv'

export default GoogleApiWrapper({
    apiKey: 'AIzaSyBZy4v3EN_-uUaw816OaWFqNeoBoJOz9-0'
  })(GoogleMapsDiv);